import { Component, OnInit, forwardRef, Input, TemplateRef, ElementRef, SkipSelf, Host, Optional, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, ControlContainer, AbstractControl, FormControl } from '@angular/forms';
import { Helper } from 'src/app/Helper';
@Component({
  selector: 'input-file-template',
  templateUrl: './input-file-template.component.html',
  styleUrls: ['./input-file-template.component.css']
  ,
  providers: [

    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputFileTemplateComponent),
      multi: true
    }
  ]
})
export class InputFileTemplateComponent implements ControlValueAccessor, OnInit {

  propagateChange: any = () => { };
  @Input('value') _value = 0;

  @Input() template: TemplateRef<ElementRef>;
  @Input() formControlName: string;
  @Input() formControlModel: string;
  @Output() formControlModelChange: EventEmitter<boolean> = new EventEmitter<any>()
  @Input() label: string = "";
  @Input() extensionAllowed;
  @Input() maxFileSize =5;
  @Input() previewname: string = "";
  @Output() change = new EventEmitter();

  erros: any;
  filename: any;
  public control: AbstractControl;
  constructor(
    @Optional() @Host() @SkipSelf()
    private controlContainer: ControlContainer,
    public Helper: Helper) { }
  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.propagateChange(val);
  }
  getErrorMessage() {

    return this.Helper.validationErrors(this.control);
  }
  setFile(e) {
    console.log(e.target.files);
    if (e.target.files[0].size / 1024 / 1024 > this.maxFileSize) {
      this.Helper.toast(`File size should be less than ${this.maxFileSize}MB`, "error")
      return;
    }
    if (this.extensionAllowed) {
      var nam = e.target.files[0].name.split('.').pop();
      if (!this.extensionAllowed[nam]) {
        this.Helper.toast("Please upload " + Object.keys(this.extensionAllowed) + " file.", "error")
        return;
      }
    }
    this.control.setValue(e.target.files[0]);
    this.filename = this.previewname = e.target.files[0].name;
    if (this.change) this.onChange(this.control.value);
  }

  onChange(e) {
    this.change.emit(e);
    console.log(e, "onChange");
  }

  isValidFileType(fName, fType) {
    return this.extensionAllowed[fType].indexOf(fName.split('.').pop()) > -1;
  }
  ngOnInit() {


    if (this.controlContainer) {
      if (this.formControlName) {
        this.control = this.controlContainer.control.get(this.formControlName);
        if (this.label == "") {
          let lab = this.formControlName.split('_');
          lab = lab.map(v => {
            return v.charAt(0).toUpperCase() + v.slice(1)
          })
          this.label = lab.join(" ");

        }
      } else {
        this.control = new FormControl(this.formControlModel)

        this.control.valueChanges.subscribe(x => {
          this.formControlModelChange.emit(x);
        })
      }
    } else {

        this.control = new FormControl(this.formControlModel)

        this.control.valueChanges.subscribe(x => {
          this.formControlModelChange.emit(x);
        })

        // console.warn('Missing FormControlName directive from host element of the component');

    }
  }
  writeValue(value) {
    if (value) {
      this.value = value;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() { }

}
